<template>
    <div class="alert alert-danger" :class="customClass" v-if="errorData && errorData.length">
        <span v-for="error in errorData">{{ error }}<br /></span>
    </div>
</template>
<script>
import {EventBus} from '../../EventBus';

export default {
        name: "ValidationError",
        mounted()  {
            EventBus.on('all-forms-cancelled', this.clearErrors);
        },
        props: {
            errors: {
                type: Array,
            },
            customClass: {
                type: String,
                default: ""
            },
        },
        data: function() {
          return {
              errorData: this.errors,
          }
        },
        methods: {
            clearErrors: function () {
                this.errorData = null;
            }
        }
    }
</script>
